import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueCompositionAPI from '@vue/composition-api';
import erwa from '@58fe/erwa-sdk';

Vue.config.productionTip = false;

Vue.use(VueCompositionAPI);

erwa.init({
	id: 443, // 页面 id
	random: 0.5 // 抽样 (0-1] 1-全量 （选填，默认0.5）
});

new Vue({
	router,
	render: (h) => h(App)
}).$mount('#app');
